import { atom } from "recoil";

export const timerAtom = atom({
  key: "timerAtom",
  default: {
    title: "",
    duration: "",
  },
});
